import type { IncludedDiscountType } from "@shared/graphql.types"

export const useIsKitMembership = (
  discounts?: Array<IncludedDiscountType> | undefined
): boolean => {
  return !!discounts?.some(
    (discount) =>
      discount?.name === "100% off per item" &&
      discount?.type === "membership" &&
      (discount?.value === 59 || discount?.value === 30)
  )
}
